import { render, staticRenderFns } from "./PropertyPage.vue?vue&type=template&id=5fc52fe9&scoped=true&"
import script from "./PropertyPage.vue?vue&type=script&lang=js&"
export * from "./PropertyPage.vue?vue&type=script&lang=js&"
import style0 from "./PropertyPage.vue?vue&type=style&index=0&id=5fc52fe9&lang=scss&scoped=true&"
import style1 from "./PropertyPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc52fe9",
  null
  
)

export default component.exports